/**
 * Shared constants
 */

/** Single source of truth for app version (add-in and API). Update when releasing. */
export const APP_VERSION = "1.0.1";

export const API_BASE_URL = process.env.API_BASE_URL || "https://aoa.cloudguy.app/api";

export const FEATURE_NAMES = {
  SUMMARIES: "summaries",
  LINKS: "links",
  SPOOF_DETECTION: "spoofDetection",
  ACTIONS: "actions",
  AUTOMATION: "automation",
  DASHBOARD: "dashboard",
} as const;

export const SPOOF_SCORE_THRESHOLDS = {
  TRUSTED: 20,
  SUSPICIOUS: 60,
  HIGH_RISK: 80,
} as const;

export const RISK_LEVELS = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
  CRITICAL: "critical",
} as const;

export const ACTION_CATEGORIES = {
  BUSINESS: "business",
  SECURITY: "security",
  ORGANIZATION: "organization",
} as const;

export const DEFAULT_FEATURE_TOGGLES = {
  summaries: true,
  links: true,
  spoofDetection: true,
  actions: true,
  automation: true,
  dashboard: true,
};

/** Default summary length when summaries are enabled. */
export const DEFAULT_SUMMARY_LENGTH = "short" as const;

export const DEFAULT_TASK_PANE_CONFIG = {
  position: "right" as const,
  width: 350,
  autoCollapse: false,
  defaultExpanded: true,
};





